<template>
  <page-template>
    <template slot="title">
      <page-title
        :title="pageTitle"
        :back-to="navigateBackRoute"
      />
    </template>
    <template slot="content">
      <v-row>
        <v-col>
          <v-card v-if="!removeCard">
            <div
              v-if="displayTop"
              class="d-flex align-center justify-end pa-8 flex-wrap content-top"
            >
              <component
                :is="searchComponent"
                v-if="searchComponent"
                :options="searchOptions"
              />
              <component
                :is="totalsComponent"
                v-if="totalsComponent"
              />
              <v-spacer />
              <component
                :is="filterComponent"
                v-if="filterComponent"
              />
              <component
                :is="reportComponent"
                v-if="reportComponent"
              />
              <component
                :is="getDisplaySpeedFilter"
                v-if="getDisplaySpeedFilter"
              />
              <component
                :is="removeButton"
                v-if="removeButton"
              />
              <v-btn
                v-if="newRouteName"
                class="ml-4"
                color="primary"
                :to="{ name: newRouteName }"
              >
                <span class="white--text no-transform">{{ btnText }}</span>
              </v-btn>
            </div>
            <total-to-remove v-if="removeButton" />
            <component :is="pageContent" />
          </v-card>
          <component
            :is="pageContent"
            v-else
          />
        </v-col>
      </v-row>
    </template>
  </page-template>
</template>

<script>
import PageTitle from 'Arch/template/PageTitle.vue';
import PageTemplate from 'Arch/template/PageTemplate.vue';
import RouterMixin from 'Arch/mixins/RouterMixin';
import NotificationMixin from '../../mixins/NotificationMixin';
import TotalToRemove from './components/TotalToRemove.vue';

export default {
  name: 'CrudListTemplate',
  components: {
    PageTitle,
    PageTemplate,
    TotalToRemove,
  },
  mixins: [RouterMixin, NotificationMixin],
  computed: {
    searchOptions() {
      return this.$route.meta.crud.searchOptions;
    },
    searchComponent() {
      return this.$route.meta.crud.searchComponent;
    },
    filterComponent() {
      return this.$route.meta.crud.filterComponent;
    },
    pageTitle() {
      return this.$route.meta.crud.pageTitle;
    },
    navigateBackRoute() {
      return this.$route.meta.crud.navigateBackRoute;
    },
    btnText() {
      return this.$route.meta.crud.btnText;
    },
    newRouteName() {
      return this.$route.meta.crud.newRouteName;
    },
    pageContent() {
      return this.$route.meta.crud.pageContent;
    },
    reportComponent() {
      return this.$route.meta.crud.reportComponent;
    },
    totalsComponent() {
      return this.$route.meta.crud.totalsComponent;
    },
    getDisplaySpeedFilter() {
      return this.$route.meta.crud.speedFilter;
    },
    removeButton() {
      return this.$route.meta.crud.removeButton;
    },
    removeCard() {
      return this.$route.meta.crud.removeCard;
    },
    displayTop() {
      return this.getDisplaySpeedFilter
        || this.reportComponent
        || this.newRouteName
        || this.removeButton
        || this.totalsComponent
        || this.searchComponent
        || this.filterComponent;
    },
  },
};
</script>
<style scoped>
.content-top {
  gap: 8px;
}
</style>
